<template>
  <v-container>

    <v-card v-for="card in cards" v-if="cards">
      <v-layout row wrap class="pa-3">
        <v-flex v-html="card.question" class="pa-2 blue--text" xs12 md8></v-flex>
        <v-flex class="px-2" xs12 md4>
          <img width="100%" :src='card.question_image'>
        </v-flex>
        <v-flex v-html="card.answer" class="pa-2" xs12 md8></v-flex>
        <v-flex class="px-2 text-right" xs12 md4>
          <img width="100%" :src='card.answer_image'>
        </v-flex>

      </v-layout>
    </v-card>


  </v-container>

</template>

<script>
import db from '@/fb'

export default {
  name: 'Outline',
  data() {
    return {
      cards: null,
      deckId: null,
    }
  },
  mounted() {
    this.deckId = this.$route.params.id
    this.getIndividualCards(this.deckId)
  },
  methods: {
    getIndividualCards(deckId) {
      console.log('test')
      this.cards = []
      return firebase.firestore().collection('cards').where('deck', '==', deckId).orderBy('created', 'desc').get().then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          this.cards.push(item)
        })
        this.cards = this.cards.reverse()
      })
    },

  }
}
</script>
